<template>
  <div class="message-box">
    <b-modal ref="modal-window" :title="title" size="lg modal-fullscreen-xxl-down" modal-class="message-box-modal">
      <template #modal-body>
          <Textarea
              v-model="comment"
              :label="$t('client.comment')"
              :rows="3"
              :error="v$.comment.$error ? $t('object.error.actionComment') : ''"
          />
      </template>>

      <template #modal-footer>
        <span class="btn btn-secondary" @click="close()">{{ $t('client.cancel') }}</span>
        <span class="btn btn-primary" @click="submit()">{{ $t('client.create') }}</span>
      </template>
    </b-modal>
  </div>
</template>

<script src="./ActionComment.js"></script>
